import React from 'react';
import styled from './styled';
import Modal from './BaseModal';
import Icon from './Icon';

import * as Colors from '../helpers/Colors';
import PressableWithOpacity from './PressableWithOpacity';

interface CustomModalProps {
  children?: React.ReactNode;
  isVisible: boolean;
  title: string;
  dismissModal: () => void;
}

export const CustomModal: React.FC<CustomModalProps> = ({
  children,
  isVisible,
  title,
  dismissModal,
}) => {
  return (
    <CustomizedModal
      testID={'modal'}
      isVisible={isVisible}
      propagateSwipe
      onBackButtonPress={dismissModal}
      onBackdropPress={dismissModal}
      onSwipeComplete={dismissModal}
      swipeDirection={['down']}>
      <Container>        
        <KnobContainer>
          <ModalKnob />
        </KnobContainer>
        <Header>          
          <HeaderText> {title}</HeaderText>
          <CloseButton onPress={dismissModal}>
            <CloseIcon />
          </CloseButton>
        </Header>
        <Body>{children ? children : null}</Body>
      </Container>
    </CustomizedModal>
  );
};

//@ts-ignore known issue https://github.com/react-native-modal/react-native-modal/issues/381
const CustomizedModal = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
  max-height: 100dvh;
`;

const Container = styled.SafeAreaView`
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 10px 20px;
  background: white;
  max-height: 85%;
`;
const KnobContainer = styled.View`
  justify-content: center;
  align-items: center;
  flex: 0;
  padding: 10px;
`;
const ModalKnob = styled.View`
  background: lightgray;
  height: 4px;
  width: 40px;
  border-radius: 25px;
`;

const Header = styled.View`
  flex-direction: row !important;
  align-items: center;
  padding: 10px;
  border-bottom-color: lightgray;
  border-bottom-width: 1px;
  align-items: flex-start;
`;

const HeaderText = styled.Text`
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
`;

const Body = styled.ScrollView`
  padding: 0px 10px;
`;

const CloseButton = styled(PressableWithOpacity).attrs({
  hitSlop: 6,
})``;

const CloseIcon = styled(Icon).attrs({
  name: 'close',
  color: Colors.primary,
})`
  font-size: 24px;
  padding: 2px;
`;
